import { RouteObject } from 'react-router-dom';
import { MenuItem, items } from '@/configs/routes';
import RequireAuth from '@auth/RequireAuth'

const generateRoutes = (items: MenuItem[]): RouteObject[] => {
    return items.map((item) => {
        const element = item.protected ? <RequireAuth requiredRoles={item.roles}>{item.element as React.JSX.Element}</RequireAuth> : item.element

        const route: RouteObject = {
            path: item.path,
            element
        };

        if (item.children?.length) {
            route.children = generateRoutes(item.children);
        }

        return route;
    });
};

const appRoutes: RouteObject[] = generateRoutes(items)

export default appRoutes
